import axios from "axios";
import config from "../../settings/config";
import { handleError } from "../../network/servicErrorHandling";

axios.defaults.headers.common["Authorization"] = localStorage.getItem(
  `${window.location.hostname}_token`
);

async function shops(searchKey, url, category) {
  if (!searchKey) {
    searchKey = "";
  }
  if (!url) {
    url = config.baseUrl + `v1/shops?q=${searchKey}&category=${category}`;
  }
  return Promise.resolve().then((v) =>
    axios
      .get(url.replace("http:", "https:"))
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function addToCart(shop_uid, productId) {
  axios.defaults.headers.common["Authorization"] = localStorage.getItem(
    `${window.location.hostname}_token`
  );
  return Promise.resolve().then((v) =>
    axios
      .get(
        `${config.baseUrl}v1/shops/${shop_uid}/cart/product/add/${productId}`
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err, productId);
      })
  );
}
async function changeQuantity(shop_uid, productId, product_quantity) {
  return Promise.resolve().then((v) =>
    axios
      .get(
        config.baseUrl +
          `v1/shops/${shop_uid}/cart/product/change/${productId}/${product_quantity}`
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function clients_config(type) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/clients/config?${type && type}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function accounts() {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/users/accounts`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function spam(params) {
  axios.defaults.headers.common["Authorization"] = localStorage.getItem(
    `${window.location.hostname}_token`
  );
  return Promise.resolve().then((v) =>
    axios
      .post(`${config.baseUrl}v1/spams`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function create_media(params) {
  return Promise.resolve().then((v) =>
    axios
      .post(`${config.baseUrl}v1/medias/`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function states() {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/geo/states/`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function cities(stateUid) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/geo/cities/?state=${stateUid}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function terms(termId) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/terms-of-use/sections/${termId}/items`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export {
  terms,
  shops,
  addToCart,
  changeQuantity,
  clients_config,
  accounts,
  spam,
  create_media,
  states,
  cities,
};
